// Program calendar helpers. The program's IANA time zone (set in ops, sent in
// the member-safe program payload) decides when the daily bonus resets.

export const DEFAULT_PROGRAM_TIMEZONE = "Asia/Kuala_Lumpur";

const formatDayKey = (timeZone, now) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);

/** 'YYYY-MM-DD' of `now` in the program's time zone (default UTC+8). */
export function getDayKey(timeZone, now = new Date()) {
  try {
    return formatDayKey(timeZone || DEFAULT_PROGRAM_TIMEZONE, now);
  } catch (_) {
    return formatDayKey(DEFAULT_PROGRAM_TIMEZONE, now);
  }
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Time left until `start` as one unit for "Starts in …":
 * { unit: 'days' | 'hours' | 'minutes', count } or null once started.
 */
export function getStartsIn(start, now = Date.now()) {
  const startMs = new Date(start).getTime();
  if (!Number.isFinite(startMs)) return null;
  const left = startMs - now;
  if (left <= 0) return null;
  if (left >= DAY) return { unit: "days", count: Math.floor(left / DAY) };
  if (left >= HOUR) return { unit: "hours", count: Math.floor(left / HOUR) };
  return { unit: "minutes", count: Math.max(1, Math.ceil(left / MINUTE)) };
}
